import { useAppSelector } from '@frontend/common';
import { SelectOption } from '@frontend/components/basic-forms';
import { UserAction, UserActionName } from '@frontend/user/types';
import { fetchGeneralWorkflowActions, workflowSharedStore } from '@frontend/workflow/redux';
import { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { UserActionSelectProps } from './user-action-select.component';

interface ViewProps {
    options: SelectOption<UserActionName>[];
}

const useUserActionSelect = (props: UserActionSelectProps): ViewProps => {
    const workflowSharedState = useAppSelector(useSelector, workflowSharedStore);

    useEffect(() => {
        props.dispatch && props.dispatch(fetchGeneralWorkflowActions());
    }, []);

    const options = useMemo(() => {
        if (!workflowSharedState.generalWorkflowActions) return [];
        const entityActions = Object.values(UserActionName);
        return [...entityActions, ...workflowSharedState.generalWorkflowActions]
            .filter((action) => (props.subset ? props.subset.includes(action) : true))
            .map((action) => {
                const found = UserAction.ALL.find((a) => a.value === action);
                if (found) return { value: found.value as UserActionName, label: found.value as UserActionName, display: found.displayName };
                return { value: action as UserActionName, label: action.replace(/_/g, ' ') as any };
            });
    }, [workflowSharedState.generalWorkflowActions, props.subset]);

    return { options };
};

export default useUserActionSelect;
